import { Component, Input } from "@angular/core";

@Component({
  selector: "app-best-interest-account",
  templateUrl: "./best-interest-account.component.html",
})
export class BestInterestAccountComponent {
  @Input() date = "2024-08-02";
}
